
const patternApi = {

    async getPatternsAvailable(){
        const patterns = await fetch(window.location.origin+ '/api/v1/configurator/patterns/available')
            .then(results => {
                return results.json();
            })
        return patterns;
    },

    async getPatternAttributes(patternId, value){
        const attributes = await fetch(window.location.origin + '/api/v1/configurator/patterns/' + patternId + '?code=' + value)
            .then(results => {
                return results.json();
            })
        return attributes
    },

    async getPatternConfiguration(quoteId, groupId){
        const response = await fetch(window.location.origin + '/api/v1/configurator/quotes/' + quoteId + '/patterns/'+groupId+'/edit', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        }).then(results => {
            return results.json();
        })
        return response;
    },

    async getPatternConfigurationFromQuoteItem(quoteId, quoteItemId) {
        const response = await fetch(window.location.origin + '/api/v1/configurator/quotes/'+quoteId+'/pattern_lookup/template/' + quoteItemId, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        }).then(results => {
                return results.json();
            })
        return response;
    },


    async getPatternModulesFromSelections(data, patternId){
        const response = await fetch(window.location.origin + '/api/v1/configurator/patterns/' + patternId + '/lookup_modules', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        }).then(results => {
            return results.json();
        })

        return response;
    }

};

export default patternApi;